// src/components/features/Elevation/components/ElevationStep6CncTerracotta.jsx
// CNC / Terracotta jaali work — swipe-style selection (folder "3. CNC,
// terracotta" me "Radio" naam nahi tha, isliye swipe UI use kiya)

import ElevationSwipeStep from "./shared/ElevationSwipeStep";
import { CNC_TERRACOTTA_IMAGES } from "../../../../assets/Elevation/elevationAssets";

export default function ElevationStep6CncTerracotta(props) {
  return (
    <ElevationSwipeStep
      {...props}
      title="CNC / Terracotta Work"
      subtitle="Swipe through CNC & terracotta jaali styles and pick what you like"
      items={CNC_TERRACOTTA_IMAGES}
      selectedFieldKey="elevationCncTerracotta"
      likedFieldKey="elevationLikedCncTerracotta"
    />
  );
}
